import { Flex, useDisclosure } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { MapIcon, RanaButton, RanaForm, RanaModal, SubmitFunction } from "@nens/ranalib";

import { AddIconControl } from "@/components/add-icon-control";
import { RanaMap } from "@/lib/rana-map";

import { getIsEditable } from "../../../store/selectors";
import { usePublicationStore } from "../../../store/store";

export function MapControlHeader() {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const isEditable = usePublicationStore(getIsEditable);

  return (
    <RanaMap.ControlsHeader>
      <Flex justify="space-between" align="center" w="full">
        <Flex align="center" gap={2}>
          <MapIcon color="brand.sky" />
          <FormattedMessage id="filepreview.maps" defaultMessage="Maps" />
        </Flex>
        <NewMapModal isOpen={isOpen} onClose={onClose} />
        {isEditable && <AddIconControl onClick={onOpen} />}
      </Flex>
    </RanaMap.ControlsHeader>
  );
}

function NewMapModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const intl = useIntl();
  const addNewMap = usePublicationStore((state) => state.addNewMap);

  const doAddNewMap: SubmitFunction<{ name: string }> = ({ name }) => {
    addNewMap(name);
    onClose();
  };

  return (
    <RanaForm initialValues={{ name: "" }} doSubmit={doAddNewMap}>
      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={intl.formatMessage({
          id: "publication.map.addnewmapmodal.title",
          defaultMessage: "Add a new map",
        })}
        buttons={[
          <RanaButton key="cancel" variant="secondary" onClick={onClose}>
            <FormattedMessage id="publication.map.addnewmapmodal.cancel" defaultMessage="Cancel" />
          </RanaButton>,
          <RanaForm.SubmitButton key="submit">
            <FormattedMessage id="publication.map.addnewmapmodal.add" defaultMessage="Add map" />
          </RanaForm.SubmitButton>,
        ]}
      >
        <RanaForm.Input
          label="Enter a name for the new map"
          field="name"
          isRequired
          submitOnEnter
          mb={0}
        />
        <RanaForm.Errors />
      </RanaModal>
    </RanaForm>
  );
}
